<template>
  <div class="d-flex flex-column overflow-auto h-100">
    <div class="m-1 flex-grow-1 overflow-auto">
      <div class="flex-grow-1 overflow-auto" style="padding: 1.25rem">
        <div class="mb-3-rem">
          <v-label>{{ $t("res_Label_To") }} *</v-label>
          <v-text-field
            solo
            v-model="dispatchValues.toEmails"
            readonly
          ></v-text-field>
        </div>

        <div class="mb-1-rem">
          <v-label>{{ $t("res_Label_Subject") }} *</v-label>
          <v-text-field solo v-model="dispatchValues.subject" readonly></v-text-field>
        </div>
        <div class="mb-1-rem">
          <v-label>{{ $t("res_Label_Dispatch_DocumentNumber") }} *</v-label>
          <v-text-field solo v-model="dispatchValues.refNumber"></v-text-field>
        </div>
        <div class="mb-3-rem float-end">
          <v-btn
            class="dgs-new-button ml-2 mr-2 attachment-btn"
            :disabled="dispatchValues.attachDocuments.length >= 1"
            @click="uploadAttachment()"
          >{{
            $t("res_ButtonText_AddAttachment")
          }} *</v-btn>
        </div>
        <div
          class="mb-3-rem mt-3-rem"
          v-if="dispatchValues.attachDocuments.length !== 0"
        >
          <br /><br /><br />
          <v-label>{{ $t("res_Label_Attachments") }}</v-label>
          <v-list>
            <v-list-item
              v-for="(item, index) in dispatchValues.attachDocuments"
              :key="item.id ?? index"
              class="d-flex align-center justify-space-between"
            >
              <div class="d-flex align-center">
                <span class="ml-2 text-truncate" style="max-width: 400px">
                  {{ item.name }}
                </span>
              </div>

              <div class="d-flex align-center">
                <span class="mr-4">{{ fileSizeInKB(item.size) }} KB</span>
                <v-btn icon small color="red" @click="removeAttachment(index)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </v-list-item>
          </v-list>
        </div>

        <br /><br />
        <div class="mb-1-rem">
          <v-label>{{ $t("res_Label_ReturnDispatchedNotes") }}</v-label>
          <v-textarea
            v-model="dispatchValues.body"
            solo
            auto-grow
            rows="3"
            style="width: 100%"
            :placeholder="$t('res_Label_ReturnDispatchedNotes')"
          ></v-textarea>
        </div>
      </div>
    </div>

    <v-card-actions class="top-shadow gap-3">
      <v-btn class="light-blue flex-1" @click="closeDialog">{{
        $t("res_ButtonText_Cancel")
      }}</v-btn>
      <v-btn class="primary flex-1" @click="sendDispatch">{{
        $t("res_ButtonText_Dispatch")
      }}</v-btn>
    </v-card-actions>
    <input
      type="file"
      style="display: none"
      accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.gif,.bmp,.tif,.tiff,.msg,.rar,.zip,.7z"
      @change="onMultiFileChanged"
      ref="multiUploader"
    />
  </div>
</template>

<script>
import constants from "@/assets/js/constants.js";
import axios from "axios";

export default {
  name: "DispatchLetter",
  components: {},
  props: {
    documentId: { type: Number, default: 0 },
    senderName: { type: String, default: "" },
    referenceNumber: { type: String, default: "" },
  },
  data: function () {
    return {
      loading: false,
      dispatchValues: {
        subject: "",
        toEmails: [],
        refNumber: "",
        body: "",
        attachDocuments: [],
      },
    };
  },
  mounted() {
    this.dispatchValues.toEmails = this.senderName; 
    debugger;
    this.dispatchValues.subject = this.referenceNumber;
    this.initForm();
  },
  methods: {
    fileSizeInKB(bytes) {
      return (bytes / 1024).toFixed(2);
    },
    initForm() {
      var user = JSON.parse(sessionStorage.getItem("user"));
      this.dispatchValues.fromEmail = user.profile.Email;
      if (this.withAttachments) this.getAttachment();
    },
    closeDialog() {
      this.clearData();
      this.$emit("closeDialog");
    },
    sendDispatch: async function () {
      debugger;
      if (this.dispatchValues.attachDocuments.length === 0) {
        window.showAlert("res_Msgs_NoAttachment", "warning");
        return;
      }
      if (
        this.dispatchValues.subject === "" ||
        this.dispatchValues.refNumber === ""
      ) {
        window.showAlert("res_Msgs_FillRequired", "warning");
        return;
      }

      window.showLoading();
      var methodUrl = "Document/AddDispatch";

      // build payload compatible with backend AddDispatchDto
      var dispatchBody = {
        documentId: this.documentId,
        toEmails: this.senderName,
        emailCC: "",
        subject: this.dispatchValues.subject,
        body: this.dispatchValues.body,
        refNumber: this.dispatchValues.refNumber,
        notes: "",
        attachments: this.dispatchValues.attachDocuments.map((a) => ({
          data: a.data,
          name: a.name,
          size: a.size,
          extension: a.extension,
          contentType: a.contentType,
          isPrimary: a.isPrimary,
        })),
      };

      axios
        .post(constants.baseApiUrl + methodUrl, dispatchBody, {
          headers: constants.headers,
        })
        .then((res) => {
          if (res.data) {
            window.hideLoading();
            window.showAlert("res_Msgs_EmailDispatched", "success");
            this.closeDialog();
          } else {
            window.hideLoading();
            window.showAlert("res_Msgs_Warning", "warning");
          }
        })
        .catch((err) => {
          console.warn(err);
          window.hideLoading();
        });
    },
    clearData: function () {
      this.dispatchValues = {
        toEmails: [],
        subject: "",
        body: "",
        refNumber: "",
        attachDocuments: [],
      };
    },
    uploadAttachment() {
      if (this.dispatchValues.attachDocuments.length >= 1) {
        return;
      }
      this.$refs.multiUploader.click();
      this.$refs.multiUploader.value = "";
    },
    async onMultiFileChanged(event) {
      const files = event.target.files;
      if (!files || files.length === 0) return;

      if (this.dispatchValues.attachDocuments.length >= 1) {
        window.showAlert(this.$t("res_Msgs_MaxAttachmentsAllowed", { count: 1 }), "warning");
        return;
      }

      const allowedExtensions = constants.fileExtensions.map((ext) =>
        ext.name.toLowerCase()
      );

      const filePromises = Array.from(files)
        .slice(0, 1)
        .map(async (file) => {
        const extension = file.name.split(".").pop().toLowerCase();

        // Check allowed extension
        if (!allowedExtensions.includes(extension)) {
          window.showAlert("res_Msgs_AttachmentTypeNotAllowed", "warning");
          return null;
        }

        // Check file size
        if (file.size > constants.maxSize) {
          window.showAlert(
            this.$t("res_Msgs_AttachmentSizeExceeded", {
              size: constants.maxSize / (1024 * 1024),
            }),
            "warning"
          );
          return null;
        }

        const base64Data = await this.readFileAsBase64(file);
        return {
          data: base64Data,
          name: file.name,
          size: file.size,
          extension,
          contentType: file.type,
          isPrimary: false,
        };
      });

      const newAttachments = (await Promise.all(filePromises)).filter(Boolean);

      // Ensure total attachments
      const remainingSlots = 1 - this.dispatchValues.attachDocuments.length;
      const attachmentsToAdd = newAttachments.slice(0, remainingSlots);

      this.dispatchValues.attachDocuments.push(...attachmentsToAdd);

      if (newAttachments.length > remainingSlots) {
        window.showAlert(
          this.$t("res_Msgs_MaxAttachmentsAllowed", {
            count: 1,
          }),
          "warning"
        );
      }

      // Reset file input
      this.$refs.multiUploader.value = "";
    },
    readFileAsBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result.split(",")[1]);
        reader.onerror = (err) => reject(err);
        reader.readAsDataURL(file);
      });
    },
    removeAttachment(index) {
      this.dispatchValues.attachDocuments.splice(index, 1);
    },
  },
  watch: {
    dialogModelShow(newVal, oldVal) {
      if (this.dialogModelShow) {
        this.clearData();
        this.initForm();
      } else this.clearData();
    },
  },
};
</script>

<style scoped>
.v-icon.v-icon.v-icon--link {
  cursor: pointer;
  outline: none;
  left: 0% !important;
  position: relative !important;
}

.v-list-item[aria-expanded="true"] {
  color: #000 !important;
  background: #bfd1e447;
  border-radius: 6px;
}

::v-deep .attachment-btn {
  background-color: #ebf1f6 !important;
  color: inherit !important;
  box-shadow: none !important;
}

::v-deep .attachment-btn.v-btn--disabled {
  opacity: 1 !important;
  background-color: #ebf1f6 !important;
  color: inherit !important;
  box-shadow: none !important;
}
</style>
